/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Seat_Price_Free_MemberInputs */



/**
* | output |
* | --- |
* | "They move into a {type} seat you already pay for." |
*
* @param {Seat_Price_Free_MemberInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_price_free_member = /** @type {((inputs: Seat_Price_Free_MemberInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Price_Free_MemberInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Das Mitglied wechselt auf einen ${i?.type}-Platz, den Sie bereits bezahlen.`)
	return /** @type {LocalizedString} */ (`They move into a ${i?.type} seat you already pay for.`)
});